import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DatasetFacade, PublishOption, PublishState } from '@mode/dataset/contract';

@Component({
  selector: 'mode-dropdown-context-menu',
  templateUrl: './dropdown-context-menu.component.html',
  styleUrls: ['./dropdown-context-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropDownContextMenuComponent {
  @Input() isDirty = false;
  @Input() datasetToken = 'not-provided';
  @Input() datasetShareLink = '';
  @Input() isPersonal = true;
  @Input() modeStudioEnabled = false;
  @Input() canSaveCodeChanges = true;
  @Input() canSyncToGithub = false;
  @Input() githubLink: string | undefined;
  @Input() publishOption: PublishState = null;
  @Input() showGoToDataWorkspace = false;
  @Input() thoughtspotDataWorkspaceLink = '';

  @Output() handleSave = new EventEmitter();
  @Output() viewOrPreviewDataset = new EventEmitter();
  @Output() handleUseInNewReport = new EventEmitter();
  @Output() handleGithubSync = new EventEmitter();
  @Output() publishOptionClicked = new EventEmitter<PublishOption>();
  readonly tooltipContent = `<p style="text-align:left">Schedules are only available on Mode Business plans. Upgrade to run your data on a cadence."</p>`;

  constructor(private datasetFacade: DatasetFacade) {}

  openDatasetDeletionModal() {
    this.datasetFacade.openDeleteDatasetModal(this.datasetToken);
  }
}
